exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".YrdLOnp5hhbrOp4X7E5Th{border-bottom:.07143rem solid #ccc;padding:.71429rem 1.42857rem}.jHVtKtrNJBIM7c5rLtPmu{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:1.125em;font-weight:600;margin-right:1.42857rem}._19DZtAEpV0skPveiDLkEau{padding:.71429rem 0}._39aliJKj2W3GKGzr9rxsfH{padding:.71429rem 1.42857rem 1.42857rem}.HVlEvw9iQmcbCPstEE5aB{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-style:normal;padding:.71429rem 0 2.14286rem}.j-OPMf1MN2ESsCwGqvJr3{margin-right:.35714rem}._1mjijXv5zphQf6k96IEkhQ{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"AddFreeTextDialog_title": "YrdLOnp5hhbrOp4X7E5Th",
	"AddFreeTextDialog_title_text": "jHVtKtrNJBIM7c5rLtPmu",
	"AddFreeTextDialog_subTitle": "_19DZtAEpV0skPveiDLkEau",
	"AddFreeTextDialog_content": "_39aliJKj2W3GKGzr9rxsfH",
	"AddFreeTextDialog_content_info": "HVlEvw9iQmcbCPstEE5aB",
	"AddFreeTextDialog_content_info_icon": "j-OPMf1MN2ESsCwGqvJr3",
	"AddFreeTextDialog_buttons": "_1mjijXv5zphQf6k96IEkhQ"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/CoveredInClass/AddFreeTextDialog/style.postcss
// module id = 1566
// module chunks = 0